<template>
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">
    <van-nav-bar
      title="我的记录"
      id="topbar"
      style="background-color: #4263EB"
    >
      <template #right>
        <div style="border: 0px solid;line-height: 50px">
          <van-icon name="chat-o" :badge="notReadMessageCount" v-if="notReadMessageCount!==0" size="25" @click="$router.push({name:'common-messageList',params:{backPath: 'feature-foo'}})" />
          <van-icon name="chat-o" v-else size="25" @click="$router.push({name:'common-messageList',params:{backPath: 'feature-foo'}})" />
        </div>
      </template>
      <template #title>
        <div style="border: 0px solid;line-height: 50px">
          <span style="color:#fff ">已完成 {{list.length}}</span>
        </div>
      </template>
      <template #left>
        <div>
          <van-dropdown-menu style="height: 30px;background-color: #4263EB">
            <van-dropdown-item v-model="regionValue" :options="regionSelect" />
          </van-dropdown-menu>
        </div>
      </template>
    </van-nav-bar>
    <van-notice-bar  left-icon="volume-o" style="margin-top:-2px;position: fixed;width: 100%;z-index: 9999" scrollable :text="messageText" v-if="notReadMessageCount!==0" />
    <div style="height: 30px" v-if="notReadMessageCount!==0"></div>
    <div style="z-index:9999;width: 100%;margin-top: 5%">
      <form action="/">
        <van-search
          style="height: 50px;width: 90%;margin-left: 5%;border-radius: 10px"
          v-model="searchValue"
          show-action
          placeholder="请输入搜索关键词"
          @search="onSearch"
          @cancel="onCancel"
          shape="round"
        />
      </form>
    </div>
    <img v-if="list.length>3" src="../../assets/back-top.png" style="width: 40px;height: 40px;position: fixed;bottom: 230px;right: 0px" @click="backTop">
    <img  src="../../assets/refresh.png" style="width: 35px;height: 35px;position: fixed;bottom: 180px;right: 0px" @click="onRefresh">
    <van-loading type="spinner" color="#1989fa" v-if="isLoading" style="position: absolute;top: 300px;margin-left: 30%">
      数据加载中...
    </van-loading>
<!--    <van-pull-refresh v-model="isLoading" @refresh="onRefresh" >-->
      <div v-if="list.length>0">
        <div v-for="(item,index) in list" :key="index" class="item2">
          <div>
            <div  class="item2-top"  >
              <!--                <span style="font-size:14px;">
                                {{item.operationDate}}
                              </span>
                              <p style="float: right;margin-right: 5px;color: orange"
                                 >
                                驳回，待提交
                              </p>
                              <p style="float: right;margin-right: 5px;color: pink"
                                 v-if="item.reviewState === 'REVIEW_STATS_DTJ'">
                                待检查
                              </p>-->


              <div class="item2-top-left1">

              </div>
              <div class="item2-top-date">
                <p style="color: #000000;opacity: 1">
                  {{item.operationDate}}
                </p>
              </div>
              <div class="item2-top-status">
                <van-tag   type="success" style="width: 68px;height:30px;margin-right:7%;border-radius: 6px;background: #ED773B19;margin-top: 3%;text-align: center;color:#ED773B ">已提交</van-tag>
              </div>
            </div>
            <div class="item2-context">

              <div class="item2-context1"  @click="showItem(item)">
                <div  :class="item.pointName.length>12? 'item2-context1-item1 white-space-break-word': 'item2-context1-item1 white-space-nowrap' ">
                  {{item.pointName}}
                </div>
                <div class="item2-context1-item2">
                  {{item.districtName}}/{{item.townName}}
                </div>
              </div>
              <div class="item2-context2" >

                  <span style="font-size: 13px;font-weight: bold"  @click="showItem(item)">
                    {{item.pointCode}}
                  </span>
                <span style="font-size: 13px;font-weight: bold;color: #878484" @click="showItem(item)" >
                    |
                  </span>
                <span style="font-size: 13px;color: #6c6b6b"  @click="showItem(item)">
                    {{item.taskName}}
                </span>

                <div v-show="item.garbageChamber==='1'" style="width: 25%;height: 100%;float: right;margin-right: 5px" @click="showLjf(item.garbageChamberMessage)">
                  <div style="width: 50%;height: 100%;float: left;line-height: 35px;text-align: right">
                    <img src="../../assets/ljf_icon.svg">
                  </div>
                  <div style="width: 50%;height: 100%;float: left;font-size: 13px;text-indent: 0px;text-align: right">
                    <span>垃圾房</span>
                  </div>
                </div>

              </div>
              <div class="item2-bottom">
                <div class="item2-bottom-item1" @click="toMap(item)">
                  <div class="item2-bottom-item1-li1">
                    <van-icon color="#4263EB" name="location" size="18" style="margin-left: -20px" />
                  </div>
                  <div class="item2-bottom-item1-li2">
                    {{item.pointAddress}}
                  </div>
                </div>
                <div class="item2-bottom-item2">
                  <div class="item2-bottom-item2-li1">
                    <van-icon color="#4263EB" size="20" name="phone" style="line-height: 28px" />
                  </div>
                  <div class="item2-bottom-item2-li2" @click="showPopup(item.pointUserPhone)">
                    拨打
                  </div>
                </div>
              </div>
              <div class="item2-comment" v-if="item.reviewState === 'REVIEW_STATS_THJCZ' || item.reviewState === 'REVIEW_STATS_SDFH'">
                    <span style="font-size: 12px;">
                      驳回理由：
                    </span>
                <span >
                    {{item.rejectMessage}}
                  </span>
              </div>
              <div v-if="item.reviewState === 'REVIEW_STATS_THJCZ' || item.reviewState === 'REVIEW_STATS_SDFH'" class="item2-br">

              </div>

              <!--                <div>
                              <span style="font-size: 18px;font-weight: bold">
                                {{item.pointName}}
                              </span>
                                <p style="float: right;margin-right: 5px">
                                  {{item.districtName}}/{{item.townName}}
                                </p>
                              </div>
                              <div>
                              <span style="font-size: 14px;">
                                代码：{{item.pointCode}}
                              </span>
                              </div>
                              <div>
                              <span style="font-size: 14px;">
                                所属任务：{{item.taskName}}
                              </span>
                              </div>
                              <div>
                              <span style="font-size: 14px;">
                                <van-icon style="margin-left: -24px" name="location-o" size="20" />{{item.pointAddress}}
                              </span>
                              </div>
                              <div v-if="item.reviewState === 'REVIEW_STATS_THJCZ' || item.reviewState === 'REVIEW_STATS_SDFH'">
                                <p>驳回理由：</p>
                                <div style="text-indent: 20px;">
                                  <p >{{item.rejectMessage}}</p>
                                </div>

                              </div>-->

            </div>
            <!--              <div style="position: relative;left:80%;top: -80px;width: 50px">
                            <van-icon @click="callPhone(item.pointUserPhone)" name="phone-o" size="40" />
                          </div>-->

          </div>
        </div>

      </div>


      <div style="width: 100%;height: 500px;text-align: center;" v-if="list.length<1&&isLoading===false">
        <van-empty  description="暂无数据......" />
      </div>
<!--    </van-pull-refresh>-->

      <van-popup v-model="show" position="bottom" :style="{ height: '50%' }" safe-area-inset-bottom>
        <div style="height: 50px;text-align: center;font-size: 18px;font-weight: bold;margin-top: 20px">
          联系人列表
        </div>
        <div style="width: 100%;height: auto;overflow: auto">
          <van-row @click="callPhone(item)"  class="click-status" v-for="(item,index) in phoneNumbers" :key="index" style="border:1px solid #e8e8e8;height: 50px;line-height: 50px;font-size: 16px;font-weight: bold;text-align: center">
            <van-col style="width: 100%">联系人{{index+1}}</van-col>
          </van-row>
        </div>
      </van-popup>

      <van-popup v-model="ljfShow" :close-on-click-overlay="false" style="width: 80%;border-radius: 4%">
        <div style="background-color: white;width: 100%;height: auto;padding: 20px">
          <div style="font-size: 20px;font-family: PingFang SC;font-weight: bold;text-align: center;height: 60px;line-height: 60px">
            <span>垃圾房位置</span>
          </div>
          <div style="font-size: 18px;color: #00000099;font-family: PingFang SC;">
                  <span>
                    {{ljfContext}}
                  </span>
          </div>
        </div>
        <div style="height: 60px; border-top: 1px solid #CECECE;text-align: center;line-height: 58px;font-size: 18px;color:#4263EB" @click="ljfShow=false">
          <span>知道了</span>
        </div>
      </van-popup>


      <br>
      <br>




      <van-tabbar v-model="active">
        <van-tabbar-item to="../homepage">
          <span>我的任务</span>
          <template #icon="props">
            <img :src="props.active ? icon.homeInActive : icon.homeActive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="../foo">
          <span>我的记录</span>
          <template #icon="props">
            <img :src="props.active ? icon.featureInActive : icon.featureActive" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="../common/me">
          <span>我的信息</span>
          <template #icon="props">
            <img :src="props.active ? icon.meInActive : icon.meActive" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
</template>
<script>
    import $ from '@/fly'
    import {Notify, Toast,Popup} from "vant";
    import {listRecord} from "@/api/module/task/taskApi";
    import {recMsg} from "@/api/module/message/message";
    export default {
        name: 'project-proList',
        data () {
            return {
                icon: {
                    homeInActive: require('../../assets/inHomeIcon.svg'),
                    homeActive: require('../../assets/homeIcon.svg'),
                    meInActive: require('../../assets/inMeIcon.svg'),
                    meActive: require('../../assets/meIcon.svg'),
                    featureActive: require('../../assets/proIcon.svg'),
                    featureInActive: require('../../assets/inProIcon.svg')
                },
                active: 1,
                clientHeight: window.screen.height,
                clientWidth: window.screen.width,
                searchValue:'',
                index:0,
                notReadMessageCount: 0,
                userInfo:{},
                messageText:'',
                isLoading: false,
                show: false,
                phoneNumbers:[],
                phoneHeigth:5,
                regionValue: '0',
                regionSelect:[
                  {
                    text: '全部',
                    value:'0'
                  },
                ],
                ljfContext: '',
                ljfShow: false,
            }
        },
        watch:{
          regionValue(){
            this.getData(this.searchValue)
          }
        },
        computed: {
        },
        methods: {
          showLjf(context){
            this.ljfContext = context
            this.ljfShow = true
          },
          showPopup(phoneNumbers) {
            this.phoneNumbers = []

            if(phoneNumbers!==null&&phoneNumbers.length>0){
              this.phoneNumbers = phoneNumbers.split('|')
              console.log(this.phoneNumbers.length)
              this.phoneHeigth = (this.phoneHeigth + (this.phoneNumbers.length*7) ).toString()+'%'
              this.show = true;
            }else{
              Notify({ type: 'warning', message: '当前任务无联系方式！' });
            }
          },
          backTop(){
            window.scrollTo({
              top: 0,
              behavior: 'smooth' // 平滑滚动
            });
          },
          toMap(item){
            let h5Url = window.location.href
            if (window.__wxjs_environment == 'miniprogram') {
              // alert("在小程序")
              wx.miniProgram.navigateTo({ url: '/pages/map/index?longitude='+item.longitude+'&latitude='+item.latitude+'&latituname='+item.pointAddress+'&address='+item.pointAddress+'&url='+h5Url+'  ' })

            }else{
              this.$router.push({name:'feature-map',params:{item:item,pushName: 'feature-foo'}})
            }

          },
          onRefresh(){
            this.list = []
            this.getData()
          },
          showItem(pointData){
            this.$router.push({
              name:'feature-paper',
              params:{
                taskId: pointData?.taskId,
                pointId: pointData?.pointId,
                paperItemId: pointData?.paperItemId,
                index: 2,
                pointName: pointData?.pointName
              }
            })
          },
          callPhone (phoneNumber) {
            /**
             * 点位联系人电话 1.手机号 2.固话: 0XXX-XXXXXXXX-XXXXXX（多个）
             */
            window.location.href = 'tel://' + phoneNumber
          },
          onClick(name, title) {
            this.index = name;
          },
          onSearch(val) {
            this.getData(val)
          },
          onCancel() {
            this.getData()
          },
          delay(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
          },
          async getData(keyword = ''){
            if(!this.isLoading){
              this.isLoading = true
            }
            const query = {
              keyword: keyword
            }
            if(this.regionValue!=='0'){
              this.$set(query,'regionId',this.regionValue)
            }
            listRecord(query).then((res) => {
              this.list = res.data
              this.isLoading = false
            })
          },
          //查询未读消息
          getMessageList(){
            recMsg(this.userInfo.userId,1,false).then(res=>{
              this.notReadMessageCount = res.total
              if(this.notReadMessageCount!==0){
                this.messageText = this.formatTimestamp(res.rows[0].sendTime)+'：'+res.rows[0].content
              }
            })
          },
          formatTimestamp(timestamp) {
            const date = new Date(timestamp);
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0');
            const day = date.getDate().toString().padStart(2, '0');
            const hour = date.getHours().toString().padStart(2, '0');
            const minute = date.getMinutes().toString().padStart(2, '0');
            const second = date.getSeconds().toString().padStart(2, '0');
            return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
          },
          getRegion(){
            $.get(`/mobile/getProjectGroupByUserId/${this.userInfo.userId}`).then(pres=>{
              $.get('/region/select',{
                pid: pres.city
              }).then(res=>{
                for (let i = 0; i <res.length ; i++) {
                  this.regionSelect.push({
                    text: res[i].label,
                    value: res[i].value
                  })
                }
              })
            })
          },
        },
        mounted () {
          this.userInfo = JSON.parse(localStorage.getItem('USER'));
          console.log('user',this.userInfo)
          this.getRegion()
          this.getData()
          this.getMessageList()

        }
    }

</script>
<style lang="less" scoped>

/deep/.van-sticky--fixed{
  position: fixed;
  margin-top: 80px;
}
/deep/.van-ellipsis{
  color:#fff
}
/deep/.van-dropdown-menu__title::after{
  color:#fff
}
.click-status:active{
  background-color: #eaeaea;
}
.item2{
  width: 90%;
  background-color: #FFFFFF;
  margin: 0px auto;
  border-radius:25px;
  margin-top: 20px;
  .item2-top{
    height: 80px;
    text-indent: 20px;
    line-height: 60px;
    border-radius: 4px 4px 0px 0px;
    background: rgba(187,231,221,0.18);
    box-shadow: 0px 16px 64px -32px #00000028;
  }
  .item2-top-bh{
    height: 80px;
    text-indent: 20px;
    line-height: 60px;
    border-radius: 4px 4px 0px 0px;
    background: rgba(252,226,240,0.18);
    box-shadow: 0px 16px 64px -32px #00000028;

  }
  .item2-context{
    text-indent: 20px;
    line-height: 55px;
  }
}
.item2-top-left1{
  height: 85%;width: 1%;
  background-color: #00B28B;
  border-radius: 4px;
  float: left;
  margin-top: 1%;
  opacity: 0.800000011920929;
  box-shadow: 0px 16px 64px -32px #00000028;

}
.item2-top-date{
  float: left;
  height: 100%;
  color: #000000;
  font-size: 20px;
  line-height: 85px;
  letter-spacing: 0px;
  text-align: left;
  width: 49%;
}
.item2-top-status{
  width: 50%;
  height: 100%;
  text-align: right;
  float: left;
  color: #ED773B;
}

.item2-context1{
  height: 90px;
  width: 95%;
  margin: 0px auto;
}
.item2-context1-item1{
  width: 64%;
  height: 100%;
  float: left;
  text-align: left;
  font-size: 30px;
  font-weight: bold;
  font-family: PingFang SC;
  text-indent: 0px;
}
.white-space-nowrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 90px;
}
.white-space-break-word {
  word-wrap: break-word;
  line-height: 1.5;
}
.item2-context1-item2{
  width: 36%;
  height: 100%;
  float: left;
  text-align: right;
  line-height: 90px;
  color: #52525C;

}
.item2-context2{
  height: 70px;
  width: 95%;
  line-height: 70px;
  border-bottom: 1px solid #CECECE;
  margin: 0px auto;
}

.item2-bottom{
  width: 95%;
  height: 80px;
  margin: 0px auto;
}

.item2-bottom-item1{
  height: 100%;
  width: 75%;
  float: left;
}
.item2-bottom-item2{
  height: 100%;
  width: 25%;
  float: left;

}

.item2-bottom-item1-li1{
  width: 12%;
  height: 100%;
  float: left;
  line-height: 90px;
}
.item2-bottom-item1-li2{
  width: 82%;
  height: 100%;
  float: left;
  text-align: left;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
  color: #6c6b6b;
  line-height: 80px;
}


.item2-bottom-item2-li1{
  height: 100%;
  width: 50%;
  float: left;
  line-height: 100px;
}

.item2-bottom-item2-li2{
  height: 100%;
  width:49%;
  float: left;
  font-size: 20px;
  color:#6c6b6b;
  line-height: 80px;
}


.item2-comment{
  height: 200px;
  width: 95%;
  margin: 0px auto;
  border-radius: 10px;
  background: #F5F7FE;
  overflow: auto;
}
.item2-br{
  height: 30px;
}









.infoBox{
  width: 100%;
  background-color: #1B75F6;
  padding: 30px 40px;
  border-radius: 6px;
}
.infoWarp{
  width: 100%;
  /*border: 1px solid red;*/
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  font-weight: bold;
  color: #FFFFFF;
}
.infoLeft{
  display: flex;
  align-items: center;
}
.headImg{
  width: 140px;
  height: 140px;
  border-radius: 50%;
  margin-right: 30px;
}
.infoName{
  font-size: 30px;
  line-height: 55px;
  overflow: hidden;
  font-weight: normal;
}
.infoPhone{
  overflow: hidden;
  font-size: 20px;
  line-height: 50px;
  font-weight: 400;
}
</style>
